import { useState } from 'react';

import { useNavigate } from 'react-router-dom';
import { Pager } from '../pager/pager';
import { FilterBar } from '../filter-bar/filter-bar';
import { DateTime } from '../datetime/datetime';
import { useGetCouponsQuery } from './coupons.api';
import { useAppDispatch } from '../../app/hooks';
import { open } from '../modal/modalSlice';
import { Card, CardContent } from 'shared-components';
import { PageTitle } from 'shared-components';
import Routes from '../../app/routes';

export const Coupons = () => {
  const [page, setPage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(10);
  const [search, setSearch] = useState<string | undefined>(undefined);
  const { data, isLoading } = useGetCouponsQuery({
    page,
    perPage,
    search,
  });
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  if (isLoading) {
    return <span>loading...</span>;
  }
  return (
    <>
      <PageTitle
        title="Coupons"
        crumbs={[
          { display: Routes.DASHBOARD.title, link: Routes.DASHBOARD.link },
          { display: Routes.COUPONS.title, link: Routes.COUPONS.link },
        ]}
        furtherActions={[{ value: 'create', display: 'Create Coupon' }]}
        onAction={async (action) => {
          switch (action) {
            case 'create':
              dispatch(
                open({
                  title: 'Create Coupon',
                  contentKey: 'create-coupon',
                })
              );
              break;
          }
        }}
      />
      <Card>
        <CardContent>
          <FilterBar
            //search={true}
            value={{}}
            filters={[]}
            // onFilterChanged={(values) => {
            //   setStatus(values['status']);
            // }}
            onSearch={(term) => {
              setSearch(term === '' ? undefined : term);
            }}
          />
        </CardContent>
        <table>
          <thead>
            <tr>
              <th>Code</th>
              <th>Action</th>
              <th>Active?</th>
              <th>Expires</th>
            </tr>
          </thead>
          <tbody>
            {data?.data.map((c) => (
              <tr
                onClick={() => {
                  navigate(`${c._id}`);
                }}
                key={c._id.toString()}
              >
                <td>{c.code.toUpperCase()}</td>
                <td>{c.action}</td>
                <td>{c.isActive ? 'Yes' : 'No'}</td>
                <td>
                  <DateTime d={c.expiresAt} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <Pager
          onNext={() => {
            setPage(page + 1);
          }}
          onPrevious={() => {
            setPage(page - 1);
          }}
          onPageSelected={(selected) => {
            setPage(selected);
          }}
          onPerPageChange={(selected) => {
            setPerPage(selected);
            setPage(1);
          }}
          page={page}
          perPage={perPage}
          totalPages={data?.totalPages ?? 1}
        />
      </Card>
    </>
  );
};
